import { render, staticRenderFns } from "./PresentingComplaint.vue?vue&type=template&id=b2b2e704&"
import script from "./PresentingComplaint.vue?vue&type=script&lang=ts&"
export * from "./PresentingComplaint.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b2b2e704')) {
      api.createRecord('b2b2e704', component.options)
    } else {
      api.reload('b2b2e704', component.options)
    }
    module.hot.accept("./PresentingComplaint.vue?vue&type=template&id=b2b2e704&", function () {
      api.rerender('b2b2e704', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/data-entry/inputs/PresentingComplaint.vue"
export default component.exports